import validate from "/opt/buildhome/repo/node_modules/nuxt/dist/pages/runtime/validate.js";
import flux_45global from "/opt/buildhome/repo/middleware/flux.global.js";
import manifest_45route_45rule from "/opt/buildhome/repo/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  flux_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}